import { Card, CardHeader } from '@mui/material'
import { cloneElement } from 'react'
import { Datagrid, ExportButton, Pagination, ReferenceManyField, TopToolbar, useResourceContext } from 'react-admin'

import { CardTitle } from './index'
import { SYSTEM_PERMISSION_READ } from '../../config/permissions'
import { useCommonStyles } from '../../config/theme'
import { useResourcePermissions } from '../../domain/permissions'
import { useSmallScreen } from '../../utils/theme'

export const ListReference = ({ children, classes: classesOverride = {}, ...props }) => {
  const [hasRead] = useResourcePermissions(props.reference, SYSTEM_PERMISSION_READ)
  return hasRead ? (
    <Card sx={{ mt: 3 }}>
      <ReferenceManyField {...props} perPage={10} pagination={<Pagination />}>
        {cloneElement(children, { isChildOfListReference: true })}
      </ReferenceManyField>
    </Card>
  ) : null
}

export const ListActions = ({ hasExport = false, children }) => {
  return (
    <TopToolbar sx={{ boxSizing: 'content-box' }}>
      {children}
      {hasExport && <ExportButton meta="export" maxResults={100000} />}
    </TopToolbar>
  )
}

export const ListCardTitle = () => {
  const resource = useResourceContext()
  return <CardTitle text={`resources.${resource}.name`} args={2} />
}

export const ListDatagrid = ({ children, expand, isChildOfListReference, rowClick = 'show', ...props }) => {
  const commonClasses = useCommonStyles()
  return (
    <Datagrid
      {...props}
      bulkActionButtons={false}
      expand={expand}
      rowClick={expand ? 'expand' : rowClick}
      sx={{
        '& .RaDatagrid-headerRow': { backgroundColor: 'background.faded' },
        ...(isChildOfListReference ? {} : commonClasses.datagridWithoutLastBottomBorder),
      }}
    >
      {children}
    </Datagrid>
  )
}

export const GenericListLayout = ({
  action = null,
  compactListLayout,
  isChildOfListReference = false,
  regularListLayout,
  title = <ListCardTitle />,
}) => {
  const commonClasses = useCommonStyles()
  const isSmallScreen = useSmallScreen()

  const renderMainContent = (listLayout) => (
    <>
      <CardHeader
        title={title}
        sx={{
          display: 'flex',
          alignItems: 'center',
          minHeight: 40,
          borderBottom: '1px solid',
          borderColor: 'divider',
          boxSizing: 'content-box',
          ...commonClasses.titleContainer,
        }}
        action={action}
      />
      {cloneElement(listLayout, { isChildOfListReference })}
    </>
  )

  if (isSmallScreen && !isChildOfListReference) {
    return <Card>{renderMainContent(compactListLayout)}</Card>
  }
  return renderMainContent(isSmallScreen ? compactListLayout : regularListLayout)
}
